import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';
import { MatDialog } from '@angular/material/dialog';

import { FirstConnexionComponent } from '../first-connexion/first-connexion.component';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  _user: any;

  passwordChanged = false
  constructor(private authService: AuthService, public dialog: MatDialog) { }




  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {


    // if(localStorage.getItem('user.user')){
    //   return true;
    // }



    this._user = this.authService.getUser()

    if (this._user) {
      if (this._user.premiere_connexion && this._user.type_login == "EXT") {

        const result = await this.openDialog();
        if (result) { 
          this.authService.updateFirstConnexion()
          return true 
        }
        else {

          return false
        }
      } else {
        return true;
      }

    } else {
      this.authService.logout();
      return false;
    }


  }

  async openDialog(): Promise<any> {

    const dialogRef = this.dialog.open(FirstConnexionComponent, {
      width: '400px',
      disableClose: true,
      data: { user: this._user }
    });

    return dialogRef.afterClosed().toPromise()
      .then(res => {
        return Promise.resolve(res.data);
      });
  }
}
